import { clearStoredSession } from "@acto/web-common/auth";
import type { PlatformPlugin } from "./PlatformPlugin";

/** Clears a session stored by an earlier load when the cookie check finds access. */
export async function resolveFrameSessionPersistence(
  plugin: Pick<PlatformPlugin, "mayWithholdRefreshCookie">,
): Promise<boolean> {
  if (!plugin.mayWithholdRefreshCookie) return false;
  if (!(await hasUnpartitionedCookieAccess())) return true;
  clearStoredSession();
  return false;
}

/** Assumes a browser without the Storage Access API does not block third-party cookies. */
async function hasUnpartitionedCookieAccess(): Promise<boolean> {
  if (typeof document.hasStorageAccess !== "function") return true;
  try {
    return await document.hasStorageAccess();
  } catch (error) {
    console.warn("[auth] could not check cookie access, using the stored session", error);
    return false;
  }
}
